import { render, staticRenderFns } from "./mb-aboutus.vue?vue&type=template&id=5484cb49&"
import script from "./mb-aboutus.vue?vue&type=script&lang=js&"
export * from "./mb-aboutus.vue?vue&type=script&lang=js&"
import style0 from "./mb-aboutus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports